import { areSame } from './Utils';

export class TaskArg {
  constructor(props) {
    this.step_index = props.step_index;
    this.value = props.value;
  }
}

export class StepStatus {
  constructor(props) {
    // Task that the current step is part of
    const stepIndex = ['goto', 'load_tube', 'secure_goto', 'unload_tube'].indexOf(props.step_type);
    this.task_uuid = props.task_uuid;
    this.task_type = props.task_type;
    this.step_type = props.step_type;
    this.step_index = stepIndex;
    this.task_args = {};
    for (let arg_name in props.task_args) {
      this.task_args[arg_name] = new TaskArg({
        value: props.task_args[arg_name].value,
        step_index: stepIndex,
      });
    }
  }

  current_step_args = () => {
    let result = {};
    if (this.step_index !== undefined) {
      for (let arg_name in this.task_args) {
        const arg = this.task_args[arg_name];
        if (arg.step_index === this.step_index) {
          result[arg_name] = arg;
        }
      }
    }
    return result;
  };

  /*
   * Get just the values for task args (ignoring things like step_index)
   */
  get_arg_values = () => {
    let result = {};
    for (let arg_name in this.task_args) {
      result[arg_name] = this.task_args[arg_name].value;
    }
    return result;
  };

  static areSame(lhs, rhs) {
    const methodKeys = ['current_step_args', 'get_arg_values'];
    const lhsKeys = Object.keys(lhs).sort();
    const rhsKeys = Object.keys(rhs).sort();
    if (!areSame(lhsKeys, rhsKeys)) {
      return false;
    }
    for (const k of lhsKeys) {
      const lhsVal = lhs[k];
      const rhsVal = rhs[k];
      if (methodKeys.includes(k)) {
        if (lhsVal instanceof Function && rhsVal instanceof Function) {
          // We expect these to be methods with different arguments bound for `this`
          // There's not a good way to check that so we just verify that bodies are the same and hope for the best
          if (lhsVal.toString() !== rhsVal.toString()) {
            return false;
          }
        }
        else {
          throw new Error('Methods were set to non-function values');
        }
      }
      else if (!areSame(lhsVal, rhsVal)) {
        return false;
      }
    }
    return true;
  }
}
